/**
 * Shared shape for a tool-result content block. `ToolMessage.content` is
 * polymorphic across the chain pipeline (a raw string, or a list of content
 * blocks); the only block kind the UI reads is `{ type: "text", text }`.
 *
 * Both `normalizeToolResultContent` (parseChatStream) and the long-task
 * envelope parser (`extractEnvelopeObject`) walk these blocks. They reduce the
 * array differently — one coerces every element and joins on blank lines, the
 * other keeps only text blocks and concatenates to reassemble a split JSON
 * string — so they intentionally do NOT share a join helper. They share this
 * type guard so the definition of a text block lives in one place and a future
 * change to the block shape can't drift between the two readers.
 */
export interface TextBlock {
  type: "text";
  text: string;
}

export function isTextBlock(block: unknown): block is TextBlock {
  return (
    typeof block === "object" &&
    block !== null &&
    (block as { type?: unknown }).type === "text" &&
    typeof (block as { text?: unknown }).text === "string"
  );
}
